<template>
  <div class="p-configurator" id="grade">
    <side-banner :td_id="td_id.number" :car_id="carid.number" :p_url="p_url.p_url"/>
    <confirm-reset />
    <the-title :title="title" />
    <step-menu />
    <div>
      <div>
        <ul>
          <li
            v-for="(grade, index) in item_list"
            :key="index"
            @click="clickItem(grade.code, index)"
          >
            <div class="p-configurator__inner">
              <div class="plans">
                <label class="plan">
                  <input
                    type="radio"
                    name="plan"
                    @click="select"
                    id="grade.code_name"
                    :value="grade.code"
                    v-model="check_code"
                  />
                  <div class="plan__content">
                    <div class="plan__thumb">
                      <img :src="grade.image" />
                    </div>
                    <div class="plan__detail">
                      <div class="inner_box">
                        <div>
                          <p class="plan__title renalutFont">{{ grade.name }}</p>
                          <p class="plan__subtitle">{{ grade.name_jp }}</p>
                        </div>
                        <div v-if="!(grade.status.length === 0)" style="font-size: 1.4rem;">{{ grade.status }}
                        </div>
                        <div>
                          <p class="plan__price">
                            <span>¥ {{ grade.price }}</span> ~
                          </p>
                        </div>
                      </div>
                      <div class="default_info">
                        <p class="default_info__title">主要装備</p>
                        <ul class="ul_list">
                          <li
                            v-for="(equipment, index) in splitComma(
                              grade.major_equipment
                            )"
                            :key="index"
                          >
                            {{ equipment }}
                          </li>
                        </ul>
                        <p class="engine_info__title">エンジン</p>
                        <div class="engine_info__list">
                          <span>{{ grade.engine.name }}</span>
                        </div>
                        <div class="engine_info__list enable_wrap">
                          <span>最高出力（kw (ps) /rpm）</span>{{ grade.engine.max_power }}
                        </div>
                        <div class="engine_info__list">
                          <span
                            >燃料消費率WLTCモード（{{ grade.engine.fuel_type }}）</span
                          >
                          {{ grade.engine.fuel_consumption_rate }} 
                        </div>
                        <div class="engine_info__list" v-if="grade.engine.fuel2">
                          <span
                            >{{grade.engine.fuel2}}（{{ grade.engine.fuel2_type }}）</span
                          >
                          {{ grade.engine.fuel2_consumption_rate }} 
                        </div>
                      </div>
                    </div>
                  </div>
                </label>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <bottom-banner :td_id="td_id.number" :car_id="carid.number" :p_url="p_url.p_url" />
  </div>
</template>

<script>
import { props, context, inject, reactive, ref } from "vue";
import RjConfiguration from "../functions/RjConfiguration";
import ConfirmReset from "../components/ConfirmReset.vue";
import TheTitle from "../components/Title.vue";
import StepMenu from "../components/StepMenu.vue";
import SideBanner from "../components/SideBanner.vue";
import BottomBanner from "../components/BottomBanner.vue";

export default {
  components: {
    ConfirmReset,
    TheTitle,
    StepMenu,
    SideBanner,
    BottomBanner,
  },
  setup(props, context) {
    const RJ = RjConfiguration();
    //ブラウザバック時詰め直し
    RJ.getUrlFromPathName();
    const item_list = RJ.getListGrade();
    const title = RJ.getTitle();
    const mySelect = RJ.getMySelect();
    const item_car = RJ.getDataCar();
    const check_code = RJ.getDataGreade()["code"];
    const query_key = RJ.getMenuActive()["query"];
    let td_id = reactive({ number: item_car.testdrive_id });
    let carid = reactive({ number: item_car.catalog_id });
    let p_url = reactive({ p_url: item_car.purchase_url });
    // 選択時処理
    const clickItem = (pCode, pIndex) => {
      RJ.selectConfiguration(query_key, pCode, pIndex);
    };
    const splitComma = (data) => {
      return data.split(",");
    };

    return {
      title,
      item_list,
      clickItem,
      check_code,
      splitComma,
      td_id,
      carid,
      p_url,
      item_car,
    };
  },
};
</script>
<style lang="scss" scoped>
.esp_note{
  font-weight:bold;display:inline-block;padding-left:30px;color:#c00;
}
@media (max-width: 767px) {
  .esp_note {
  display:block;
  padding-left:0;
  }
}
</style>
